import { inView } from '../utils/inview';

const animate = function () {
  $('[data-animate]').each(function () {
    const elm = $(this);
    if (inView(elm) && !elm.hasClass('animated')) {
      elm.addClass('animated');
    }
  });
};

export default animate;
